// extracted by mini-css-extract-plugin
export var externalLink = "_9t-0";
export var internalLinkLabel = "_9t-1";